/**
 * window.showConfirmation на Alpine.js + native <dialog>.
 *
 * Заменяет Bootstrap-modal вариант из public/js/modal-helper.js.
 * Разметка — resources/views/components/confirmation-dialog.blade.php (один раз в footer).
 *
 * API сохранён:
 *   window.showConfirmation(message, title?, options?) → Promise<boolean>
 *   window.confirmAction(message, onConfirm?, onCancel?)  — legacy
 *   window.confirmDelete(itemName?)                        — convenience
 *
 * Реализация: Alpine.store('confirmDialog') хранит reactive-state, рендер
 * привязывается к нему. showConfirmation() ставит state.open=true и возвращает
 * promise, разрешаемый кнопками Confirm/Cancel / закрытием dialog-а.
 */

const STORE = 'confirmDialog';

function registerStore(Alpine) {
    if (Alpine.store(STORE)) return;

    Alpine.store(STORE, {
        open: false,
        title: 'Confirm',
        message: '',
        confirmText: 'Yes',
        cancelText: 'Cancel',
        _resolve: null,

        show(opts) {
            this.title = opts.title || 'Confirm';
            this.message = opts.message || '';
            this.confirmText = opts.confirmText || 'Yes';
            this.cancelText = opts.cancelText || 'Cancel';
            this.open = true;
            return new Promise((resolve) => {
                this._resolve = resolve;
            });
        },

        confirm() {
            this._finish(true);
        },
        cancel() {
            this._finish(false);
        },
        _finish(value) {
            const resolve = this._resolve;
            this._resolve = null;
            this.open = false;
            if (resolve) resolve(value);
        },
    });
}

function exposeApi(Alpine) {
    window.showConfirmation = function (message, title, options) {
        const settings = Object.assign({ confirmText: 'Yes', cancelText: 'Cancel' }, options || {});
        return Alpine.store(STORE).show({
            message,
            title: title || 'Confirm',
            confirmText: settings.confirmText,
            cancelText: settings.cancelText,
        });
    };

    window.confirmAction = function (message, onConfirm, onCancel) {
        window.showConfirmation(message).then(function (confirmed) {
            if (confirmed && typeof onConfirm === 'function') onConfirm();
            else if (!confirmed && typeof onCancel === 'function') onCancel();
        });
    };

    window.confirmDelete = function (itemName) {
        const message = itemName
            ? 'Are you sure you want to delete "' + itemName + '"?'
            : 'Are you sure you want to delete this item?';
        return window.showConfirmation(message, 'Confirm deletion', {
            confirmText: 'Delete',
            cancelText: 'Cancel',
        });
    };
}

document.addEventListener('alpine:init', () => {
    if (window.Alpine) {
        registerStore(window.Alpine);
        exposeApi(window.Alpine);
    }
});

// Если Alpine уже стартанул до этого момента (на странице с другими модулями),
// fallback — попытка зарегистрировать сразу.
if (window.Alpine && window.Alpine.store) {
    registerStore(window.Alpine);
    exposeApi(window.Alpine);
}
